import type { Workflow } from '../../../../../api/workflows-client/workflows-client.type';
import { useTranslation } from 'react-i18next';
import { PanelList } from '../../panel-list';

export function WorkflowsList({
  workflows,
  onCreate,
  onSelectWorkflow,
  selectedWorkflowId,
}: {
  workflows: Workflow[];
  onCreate?: () => void;
  onSelectWorkflow: (workflow: Workflow) => void;
  selectedWorkflowId: string | null;
}) {
  const i18n = useTranslation();
  return (
    <PanelList
      title={i18n.t('data_management.workflows.workflows')}
      items={workflows}
      selectedItem={workflows.find((workflow) => workflow.id === selectedWorkflowId) ?? null}
      onSelect={onSelectWorkflow}
      onAddNew={onCreate ? onCreate : undefined}
      getItemId={(workflow) => workflow.id ?? ''}
      getItemDisplayText={(workflow) => workflow.name}
    />
  );
}
